<template>
    <div>
      <nav>
        <paginate
          :page-count="totalPage"
          :click-handler="goToNextPage"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :container-class="'pagination'">
        </paginate>
      </nav>
    </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
export default {
    name: "Pagination",
    props: {
        activePage: Number,
        totalPage: Number
    },
    components: {
      Paginate
    },
    data() {
        return {

        }
    },
    methods: {
        goToNextPage(pageIndex = '') {
            if (!pageIndex) {
                pageIndex = this.activePage === this.totalPage ? this.activePage : this.activePage + 1;
            }

            if (pageIndex === this.totalPage && this.activePage === pageIndex) {
                return false;
            }

            this.$emit('paginationHandle', {action: 'goToNextPage', pageIndex: pageIndex});
        }
    }
}
</script>

<style scoped></style>
